import { render } from "./CategoryConfig.vue?vue&type=template&id=db0b524e&scoped=true"
import script from "./CategoryConfig.vue?vue&type=script&lang=js"
export * from "./CategoryConfig.vue?vue&type=script&lang=js"

import "./CategoryConfig.vue?vue&type=style&index=0&id=db0b524e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0b524e"]])

export default __exports__